import React, { useState } from "react";
import MuiBox from "../MuiBox";
import MuiTypography from "../MuiTypography";
import { Button } from "@mui/material";
import { closeCenterModal } from "store/slices/CenterModal.slice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import SubmitLoaderButton from "../SubmitLoaderButton";

const CommonDeleteModal = ({
  title,
  description,
  btnName,
  onClick,
  isBtn = true,
  // btnVariant = "redContained",
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const handleDelete = () => {
    setLoading(true);
    onClick?.({
      onSuccess: () => {
        setLoading(false);
        dispatch(closeCenterModal());
      },
      onError: () => {
        setLoading(false);
      },
    });
  };

  return (
    <>
      <MuiBox
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          p: "24px",
        }}
      >
        <MuiTypography fontWeight="600" variant="20" color="text.darkBlack">
          {title}
        </MuiTypography>
        <MuiTypography fontWeight="400" variant="14" color="text.gray900">
          {description}
        </MuiTypography>
      </MuiBox>
      {isBtn && (
        <MuiBox
          sx={{
            display: "flex",
            gap: "12px",
            justifyContent: "end",
            backgroundColor: "background.gray200",
            p: "16px 24px",
          }}
        >
          <Button
            variant="whiteContained"
            onClick={() => dispatch(closeCenterModal())}
          >
            {t("commonButton.cancel")}
          </Button>

          <SubmitLoaderButton
            variant="contained"
            btnText={btnName}
            isDisable={loading}
            isLoading={loading}
            onClick={handleDelete}
            // type="submit"
            sx={{
              width: "fit-content",
              minWidth: "70px",
              bgcolor: "error.main",
              ":hover": { bgcolor: "#e12121b8" },
              "&.Mui-disabled": {
                backgroundColor: "#e12121b8 !important",
              },
            }}
          />
        </MuiBox>
      )}
    </>
  );
};

export default CommonDeleteModal;
